import { StorageHelper } from "./StorageHelper";

declare var lang: any;

export class InternationalizationHelper {

  static supportedLanguages = ["en", "de", "fr", "es"];
  static defaultLanguage = "en";
  static langFile = lang;

  static getString(key: string, language?: string): string {

    language = InternationalizationHelper.getTwoCharactersLanguage(language);
    if(!this.langFile) {
      return "";
    }

    return this.langFile[language][key] || "";
    //return this.langFile["en"][key] || "";//To test a specific language
  }

  static getStringKey(value: string): string {
    for(let l of Object.keys(this.langFile)) {
      const stringKey = Object.keys(this.langFile[l]).find(key => this.langFile[l][key] == value);
      if(stringKey) {
        return stringKey;
      }
    }
    return null;
  }

  static getTwoCharactersLanguage(language?: string): string {

    if(!language) {
      //set lang in localStorage to test a language
      let testLang = StorageHelper.getInstance().get("lang");
      if(testLang && testLang != "") {
        language = testLang;
      }
      else {
        language = InternationalizationHelper.getLanguage();
      }
    }

    //Take the first two characters only
    if(language.length > 2){
      language = language.substr(0, 2);
    }

    //If the language is not supported, use the default
    if(InternationalizationHelper.supportedLanguages.indexOf(language) == -1){
      language = InternationalizationHelper.defaultLanguage;
    }
    return language;

    //Test a language
    //return "en";
  }

  static getNavigatorLocale(currentCountry?: string): string {
    try {
      let locale = (navigator.language || '').toLowerCase();

      if (locale.match(/^[a-z]{2}-[a-z]{2}$/)) {
        return locale.split('-')[0] + '-' + locale.split('-')[1].toUpperCase();
      }

      if (locale.match(/^[a-z]{2}$/)) {
        const country = currentCountry ? currentCountry.toLowerCase() : 'us';
        return `${locale}-${country.toUpperCase()}`;
      }
      return 'en-US';
    } catch (error) {
      return 'en-US';
    }
  }

  static getLanguage(): string {

    //get the browser language
    return navigator.language || InternationalizationHelper.defaultLanguage;

    //The version of typescript curently used (2.3.4) does not support navigator.languages
    //But when it does, it would be better to use this line:
    //navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage)

    //To test a language
    //return "fr_CA";
  }

  static getCountry(): string {

    let country = InternationalizationHelper.getLanguage();
    if(country.length == 4) { //Means there is a specific country ex.: fr_CA
      country = country.substr(2);
      country = country.toLowerCase();
    }
    return country;

  }

}
